/**
 * @Author: 请在根目录下.vscode改成你的名字
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:50
 * @LastEditTime: 2019-09-27 16:00:21
 * @Version: 1.0
 * @Description: 简介
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 */
/**
 * 在组件内通用的函数
 * autor: zb
 */
import { getArea, getDict } from '@/api/common'
import { DatabaseUtil } from './databaseUtils'
import { mapGetters } from 'vuex'
import store from '@/store'
const dataBase = new DatabaseUtil()
const submitHandle = {
  get(target, key, proxy) {
    if (
      (key == 'startPlace' || key === 'stopPlace') &&
      target[key]
    ) {
      if (target[key].length > 0) {
        return target[key] instanceof Object
          ? target[key].join('#') + '#'
          : target[key]
      } else {
        return target[key].toString()
      }
    } else if ((key === 'fileUrl' || key === 'transportType') && target[key] && (typeof target[key]) === 'object') {
      return target[key].toString()
    }
    return target[key]
  }
}

const pullHandle = {
  get(target, key, proxy) {
    if (
      (key == 'startPlace' || key === 'stopPlace') &&
      target[key]
    ) {
      return String(target[key])
        .substring(0, target[key].length - 1)
        .split('#')
    }
    if (key === 'capacity') {
      const temp = /^\d+$/.test(target[key])
      if (temp) { return Number.parseInt(target[key]) } else { return target[key] }
    }
    return target[key]
  }
}

export default {
  data: function() {
    return {
      // 组件内页面状态的管理字段
      viewManager: {
        visible: false, // 是否显示
        loading: true, // 是否加载
        isEdit: false, //  是否是编辑状态
        close: () => { // 关闭
          this.viewManager.visible = false
          this.$emit('close', false)
        }
      },
      //  判断是否登陆
      isLogin: () => {
        // return new Promise((resolve, reject) => {
        const isLogin = store.getters && store.getters.userInfo && store.getters.userInfo.userId
        if (isLogin) {
          return true
          // resolve(isLogin)
        } else {
          this.$message({
            message: '请登录!',
            type: 'warning'
          })
          setTimeout(() => {
            this.$router.push('/log/login')
          }, 500)
          return false
          // reject(isLogin)
        }
        // })
      },
      //  判断用户是否认证
      isDetificate: () => {
        return new Promise((resolve, reject) => {
          if (this.userInfo.companyId && this.userInfo.companyId !== '') {
            resolve(this.userInfo)
          } else {
            this.$message({
              message: '该用户还未资质认证，请先资质认证',
              type: 'warning'
            })
            reject(this.userInfo)
            setTimeout(() => {
              this.$router.push('/personal/user/qualifications-authen')
            }, 200)
          }
        })
      },
      // 对资质认证的，进一步验证认证是否通过， 异步方法
      detificateSuccess: () => {
        return new Promise((resolve, reject) => {
          if (this.userInfo && this.userInfo.companyId && this.userInfo.companyId !== '') {
            if (this.userInfo.authStatus && this.userInfo.authStatus !== '' && this.userInfo.authStatus == '2') {
              resolve(this.userInfo)
            } else {
              this.$message({
                message: '该用户资质认证还未通过，请先等待通过资质认证',
                type: 'warning'
              })
              this.$router.push('/personal/user/qualifications-authen')
              reject(this.userInfo)
            }
          } else {
            this.$message({
              message: '该用户还未资质认证，请先资质认证',
              type: 'warning'
            })
            this.$router.push('/personal/user/qualifications-authen')
            reject(this.userInfo)
          }
        })
      },
      // 对资质认证的，进一步验证认证是否通过  同步方法
      detificateSuccessSync: () => {
        if (this.userInfo && this.userInfo.companyId && this.userInfo.companyId !== '') {
          if (this.userInfo.authStatus && this.userInfo.authStatus !== '' && this.userInfo.authStatus == '2') {
            return true
          } else {
            this.$message({
              message: '该用户资质认证还未通过，请先等待通过资质认证',
              type: 'warning'
            })
            this.$router.push('/personal/user/qualifications-authen')
            return false
          }
        } else {
          this.$message({
            message: '该用户还未资质认证，请先资质认证',
            type: 'warning'
          })
          this.$router.push('/personal/user/qualifications-authen')
          return false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText =
              'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
      }, 300)
    },
    // 转换表单的数据格式，以提交到服务器
    exchangeData(data) {
      if (window && window.Proxy) {
        const p = new Proxy(data, submitHandle)
        return Object.assign({}, p)
      } else {
        const proxyData = {}
        for (const key in data) {
          proxyData[key] = submitHandle.get(data, key)
        }
        return proxyData
      }
    },
    // 解析从服务器获取的数据， 以放入表单中
    parseData(data) {
      if (window && window.Proxy) {
        const p = new Proxy(data, pullHandle)
        return Object.assign({}, p)
      } else {
        const proxyData = {}
        for (const key in data) {
          proxyData[key] = pullHandle.get(data, key)
        }
        return proxyData
      }
    },
    // 把对象的属性值设置为空字符串
    cleanModal(modal) {
      for (const key in modal) {
        if (modal[key] !== undefined && modal[key] !== null) { modal[key] = '' }
      }
    },
    // 获取包装类型
    getPackageType() {
      if (dataBase.sessionStorageUtil.has('packageType')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.sessionStorageUtil.get('packageType')))
        })
      }
      return getDict('packageType')
        .then((data) => {
          dataBase.sessionStorageUtil.set('packageType', data.result)
          return JSON.parse(data.result)
        })
        .catch(err => {
          console.error(err)
        })
    },
    // 获取运输方式
    getTransportType() {
      if (dataBase.sessionStorageUtil.has('transportType')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.sessionStorageUtil.get('transportType')))
        })
      }
      return getDict('transportType')
        .then(data => {
          dataBase.sessionStorageUtil.set('transportType', data.result)
          return JSON.parse(data.result)
        })
        .catch(err => {
          console.error(err)
        })
    },
    // 获取付款方式
    getPayType() {
      if (dataBase.sessionStorageUtil.has('payType')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.sessionStorageUtil.get('payType')))
        })
      }

      return getDict('payType')
        .then(data => {
          dataBase.sessionStorageUtil.set('payType', data.result)
          return JSON.parse(data.result)
        })
        .catch(err => {
          console.error(err)
        })
    },
    // 获取货源类型
    getGoodsType() {
      if (dataBase.sessionStorageUtil.has('goodsType')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.sessionStorageUtil.get('goodsType')))
        })
      }

      return getDict('goodsType')
        .then(data => {
          dataBase.sessionStorageUtil.set('goodsType', data.result)
          return JSON.parse(data.result)
        })
        .catch(err => {
          console.error(err)
        })
    },
    // 获取货源类型
    getWeight() {
      if (dataBase.sessionStorageUtil.has('weight')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.sessionStorageUtil.get('weight')))
        })
      }

      return getDict('weight')
        .then(data => {
          dataBase.sessionStorageUtil.set('weight', data.result)
          return JSON.parse(data.result)
        })
        .catch(err => {
          console.error(err)
        })
    },
    /* 获取地址 */
    getArea() {
      if (dataBase.localStorageUtil.has('area')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.localStorageUtil.get('area')))
        })
      }

      return getArea()
        .then(data => {
          dataBase.localStorageUtil.set('area', JSON.stringify(data.result))
          return data.result
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 获取理化性质
    getPhysicalProperty() {
      if (dataBase.sessionStorageUtil.has('physicalProperty')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.sessionStorageUtil.get('physicalProperty')))
        })
      }

      return getDict('physicalProperty')
        .then(data => {
          dataBase.sessionStorageUtil.set('physicalProperty', data.result)
          return JSON.parse(data.result)
        })
        .catch(err => {
          console.error(err)
        })
    },
    //  地址过滤函数
    placeName(val, area) {
      const placeIds = String(val)
        .substring(0, val.length - 1)
        .split('#')
      let index = 0
      let currentVal = ''
      while (area && area.length > 0) {
        let isHas = false // 判断是否存在相对应的地址
        // 查找对应的地址名称
        for (const item of area) {
          if (item.id === placeIds[index]) {
            // 找到了则离开循环，并把当前子节点设置为area进行下一轮查找
            if (index < placeIds.length - 1) {
              currentVal += `${item.areaName}/`
            } else {
              currentVal += `${item.areaName}`
            }
            isHas = true
            area = item
            break
          }
        }
        // 如果没有找到， 则退出递归
        if (!isHas || !area.children) {
          // 没有对应的地址节点或者没有子节点就不在遍历
          break
        } else {
          area = area.children
          index++
        }
      }
      if (currentVal.charAt(currentVal.length - 1) === '/') {
        currentVal = currentVal.substring(0, currentVal.length - 2)
      }
      return currentVal
    },
    // 回到元素的上一个状态位置
    computePositionScroll(el, lastState) {
      const currentState = el.getBoundingClientRect()
      let h = currentState.y - lastState.y
      const timer = setInterval(() => {
        var step = (-h) / 8
        // 如果大于0向上取整小于0向下取整
        step = step > 0 ? Math.ceil(step) : Math.floor(step)
        h += step
        window.scrollBy(0, -step)
        if (!(h < 0)) { clearInterval(timer) }
      }, 10)
    }
  }
}
